export default __webpack_public_path__ + "maps-examples-default-styles-1200-7f88ce7d10ad9a50382690964116b2a7.png";